var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlanetscale = function SvgPlanetscale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "planetscale_svg__flex-shrink-0 planetscale_svg__block",
    width: 36,
    height: 36,
    viewBox: "0 0 44 44",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22C0 9.85 9.85 0 22 0c8.934 0 16.623 5.325 20.069 12.974L12.974 42.069a21.964 21.964 0 0 1-3.547-2.014L27.482 22H22L6.444 37.556A21.931 21.931 0 0 1 0 22ZM44 22.008 22.008 44C34.152 43.996 43.996 34.152 44 22.008Z"
  })));
};
export default SvgPlanetscale;